import styled from "styled-components";

export const Container = styled.nav`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  box-shadow: 0px 2px 4px #f0f1f2;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const BtnContainer = styled.div`
  margin-right: 16px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

export const NavbarSection = styled.div`
  margin-left: 20px;
  display: flex;
  align-items: center;
  height: 100%;
`;
